import modal from '@/utils/modal'
import ShareModal from './index.vue'

export default function openShareModal(comment) {
    modal.create(ShareModal, true, { provide: { comment }, persistent: false });
}
